import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./client";
import type { FeedbackIn, FeedbackOut, ListingDetail, ListingsResponse } from "./types";

export interface ListingsParams {
  status?: string;
  source?: string;
  sort?: string;
  dir?: "asc" | "desc";
}

function buildQuery(params: ListingsParams): string {
  const sp = new URLSearchParams();
  if (params.status) sp.set("status", params.status);
  if (params.source) sp.set("source", params.source);
  if (params.sort) sp.set("sort", params.sort);
  if (params.dir) sp.set("dir", params.dir);
  const q = sp.toString();
  return q ? `?${q}` : "";
}

export function useListings(params: ListingsParams) {
  return useQuery({
    queryKey: ["listings", params],
    queryFn: () => api<ListingsResponse>(`/listings${buildQuery(params)}`),
  });
}

export function useListing(id: number | string | undefined) {
  return useQuery({
    queryKey: ["listing", id],
    queryFn: () => api<ListingDetail>(`/listings/${id}`),
    enabled: id !== undefined && id !== "",
  });
}

export function useSubmitFeedback(listingId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: FeedbackIn) =>
      api<FeedbackOut>(`/listings/${listingId}/feedback`, { method: "POST", json: payload }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["listing", listingId] });
    },
  });
}
